module.exports = __webpack_public_path__ + "assets/img/default-room.jpg";